// extracted by mini-css-extract-plugin
export default {"container":"FeaturedCompanies_container__ImbbA","cardContainer":"FeaturedCompanies_cardContainer__5TgLX"};